import { useEffect, useState } from "react";
import { fetchGLMasters } from "../Api/ViewGLMaster";
import { Container, Table } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewGLMaster = () => {
  const [glMasters, setGLMasters] = useState([]);

  useEffect(() => {
    const loadGLMasters = async () => {
      try {
        const data = await fetchGLMasters();
        setGLMasters(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching GL Master Data`);
      }
    };

    loadGLMasters();
  }, []);

  return (
    <>
      
        <div className="">
          <Container className="list-container">
                  <div className="header-background">
            <span className="header-list-title">View GL Master</span>
                  </div>
            {glMasters.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>GL Master ID</th>
                        <th>Company Code</th>
                        <th>Bank Code</th>
                        <th>Code</th>
                        <th>Description</th>
                        <th>Account Type</th>
                        <th>Type 1</th>
                        <th>Type 2</th>
                        <th>Type 3</th>
                        <th>Created At</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {glMasters.map((glMaster, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{glMaster.glmasterId}</td>
                          <td>{glMaster.companyCode}</td>
                          <td>{glMaster.bankCode}</td>
                          <td>{glMaster.code}</td>
                          <td>{glMaster.description}</td>
                          <td>{glMaster.accountType}</td>
                          <td>{glMaster.type1}</td>
                          <td>{glMaster.type2}</td>
                          <td>{glMaster.type3}</td>
                          <td>{moment(glMaster.createdAt).format('L')} at {moment(glMaster.createdAt).format('LTS')}</td>
                          <td>{glMaster.createdBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No GL Master data found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewGLMaster;